import * as z from "zod";
import { mutator } from "./mutator";

const authorizeOAuthAppForServiceAccountSchema = z.object({
  id: z.string(),
  clientId: z.string(),
  serviceAccountId: z.string(),
});

export const authorizeOAuthAppForServiceAccount = mutator({
  schema: authorizeOAuthAppForServiceAccountSchema,
  resolve: {},
  permissions: {
    none: "compatibility no-op for retired service-account OAuth",
  },
  fn: () => Promise.resolve(),
});
